(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
			name: 'ReservationGenerateInvoice',
		},
		$iframe;

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Reservations/generateInvoice', function onload() {
			$iframe = $("iframe#invoice-preview");
			Adzuki.Form.registerForm(form);
		});
	});

	form.load = function load()
	{
		var $form                   = $('form[name="'+form.name+'"]'),
		    $form_action            = $('#reservationgenerateinvoice-action', $form),
		    $invoice_notes          = $('span.invoice-note-data', $form),
		    editor_selector_top     = '#reservationgenerateinvoice-invoice_notes-top',
		    editor_selector_bottom  = '#reservationgenerateinvoice-invoice_notes-bottom',
		    editor_top,
		    editor_bottom;

		// these 2 need to save their references so the notes dropdown can
		// insert content into them
		$(editor_selector_top, $form).on('editor.ready', function initTopEdior(e, mce) {
			editor_top = mce;
		});

		$(editor_selector_bottom, $form).on('editor.ready', function initBottomEdior(e, mce) {
			editor_bottom = mce;
		});

		// for options that have additional options only visible when checked
		$('input[type="checkbox"].options-toggle', $form).on('change', function toggleOptions() {
			var $self = $(this),
			    $opts = $self.parents('label').siblings('div.options');

			$opts.toggleClass('hidden', !$self.is(':checked'));
		});

		// invoice note select populates tinymce
		$('select.invoice-note', $form).on('change', function populateNote() {
			var $self   = $(this),
			    note    = $invoice_notes.find('[data-note-id="'+$self.val()+'"]').data('note') || '',
			    _editor = ($self.hasClass('top')) ? editor_top : editor_bottom;

			_editor.setContent(note);
			_editor.save();
		});

		$('.insert-form-link').on('click', function onClick(e)
		{
			var link_url          = $(this).data('url'),
			    link_type         = $(this).data('type'),
			    link_text         = $(this).data('text'),
			    link_res_id       = $(this).data('reservation_id'),
			    link_res_agent_id = $(this).data('reservation_agent_id'),
			    editor, // eslint-disable-line no-unused-vars
			    current_content,
			    new_content,
			    encoded_text;

			e.preventDefault();

			editor = Adzuki.Editor('#reservationgenerateinvoice-email_options-message', {
				init_instance_callback: function onEditorInit(_editor) {
					// get the editor's current content
					current_content = _editor.getContent();

					// always encode res id, agent id
					encoded_text = link_res_id + '|' + link_res_agent_id + '|';

					// append additional data based on link
					if (link_type === 'cc_auth') {
						encoded_text += $('#reservationgenerateinvoice-additional_pages-credit_card_authorization_client').val();
						encoded_text += '|';
						encoded_text += $('#reservationgenerateinvoice-additional_pages-credit_card_authorization_amount').val();
						encoded_text += '|';
						encoded_text += $('#reservationgenerateinvoice-additional_pages-credit_card_authorization_insurance').is(':checked');
					} else if (link_type === 'insurance_waiver') {
						encoded_text += $('#reservationgenerateinvoice-additional_pages-travel_protection_waiver_client').val();
					} else if (link_type === 'covid_waiver') {
						encoded_text += $('#reservationgenerateinvoice-additional_pages-pandemic_travel_waiver_client').val();
					}

					link_url = link_url + btoa(encoded_text);

					// append the link
					new_content = current_content + '<p><a href="' + link_url + '" target="_blank">' + link_text + '</a></p>';

					// set the editor to new content
					_editor.setContent(new_content);

					$('#reservationgenerateinvoice-email_options-message').val(new_content);
				},
			});
		});

		// toggle reservation overview vendors box based on include reservation overview checkbox
		$('#reservationgenerateinvoice-general_settings-include_reservation_overview').on('change', function toggleReservationOverviewDetails() {
			$('.overview-details').toggleClass('hidden', !$(this).is(':checked'));
		});

		// toggle cancellation terms and cancelled components boxes based on include cancelled components checkbox
		$('#reservationgenerateinvoice-general_settings-include_cancelled_components').on('change', function toggleCancellationDetails() {
			$('.cancellation-details').toggleClass('hidden', !$(this).is(':checked'));
		});

		// traveler settings include/mytrips state
		$('input[type="checkbox"].include-client-id', $form).on('change', function toggleMyTripsInfo()
		{
			var $self    = $(this),
			    $mytrips = $self.parents('li.table-row').find('input[type="checkbox"].mytrips-info');

			if ($self.is(':checked')) {
				$mytrips.prop('disabled', false);
			} else {
				$mytrips.prop('disabled', true).prop('checked', false);
			}

			if (!$('input[type="checkbox"].include-client-id:checked').length) {
				Adzuki.StatusMessage('warning', 'At least 1 traveler must be included in the invoice.', 'Traveler Notice');
				$self.prop('checked', true);
			}
		});

		// disallow if mytrips info is checked, and the additional mytrips page isnt
		$('input[type="checkbox"].mytrips-info', $form).on('change', function checkMyTripsPageStatus()
		{
			var $self = $(this),
			    $mytrips_page = $('#reservationgenerateinvoice-additional_pages-about_mytrips');

			if ($self.is(':checked')) {
				if (!$mytrips_page.is(':checked')) {
					$('#reservationgenerateinvoice-additional_pages-about_mytrips').prop('checked', true);
				}
			}
		});

		// uncheck traveler 'mytrips info' boxes if mytrips page is unchecked
		$('#reservationgenerateinvoice-additional_pages-about_mytrips').on('change', function uncheckMyTripsInfo() {
			if (!$(this).is(':checked')) {
				$('input[type="checkbox"].mytrips-info', $form).prop('checked', false);
			}
		});

		// BUNDLE PRICING STUFF

		// toggling include (en|dis)ables row inputs
		$('input[type="checkbox"].include', $form).on('change', function toggleInputs() {
			var $self    = $(this),
			    $row     = $self.parents('li.table-row'),
			    $bundle  = $row.find('p:nth-child(5) input'),
			    $note    = $row.find('p:nth-child(8) input');

			// if included, detect state of inputs based on settings
			if ($self.is(':checked')) {
				$bundle.prop('disabled', false);
				$note.prop('disabled', false);
			} else {
				// just disable/uncheck errthang if not included.
				// only uncheck thangs if they're checked already.
				$row.find('input').not(this).prop('disabled', true);

				$.each($row.find('input[type="checkbox"]').not(this), function checkChecked() {
					if ($(this).is(':checked')) {
						$(this).prop('checked', false).trigger('change');
					}
				});
			}

			// update the vendor total
			updateVendorTotal($self);
		});

		// toggling bundle enables display
		$('input[type="checkbox"].bundle', $form).on('change', function toggleDisplay() {
			var $self               = $(this),
			    $row                = $self.parents('li.table-row'),
			    $display            = $row.find('p:nth-child(6) input'),
			    $row_bundle         = $row.find('p:nth-child(7) span:nth-child(2)'),
			    $note               = $row.find('p:nth-child(8) input'),
			    $parent_bundle      = $row.parents('ul.table').find('li.table-row:first > p:nth-child(7) span:nth-child(2)'),
			    parent_bundle_price = accounting.unformat($parent_bundle.html()),
			    new_parent_bundle_price,
			    new_row_bundle_price;

			if ($self.is(':checked'))
			{
				if ($display.is(':disabled') && !$display.is(':checked')) {
					$note.prop('disabled', true);
				}

				$display.prop('disabled', false);
				new_row_bundle_price    = '--';
				new_parent_bundle_price = accounting.formatMoney(parent_bundle_price + $self.data('price'));
			}
			else
			{
				if (!$display.is(':disabled')) {
					$note.prop('disabled', false);
				}

				$display.prop('disabled', true);
				new_row_bundle_price    = accounting.formatMoney($self.data('price'));
				new_parent_bundle_price = accounting.formatMoney(parent_bundle_price - $self.data('price'));
			}

			$row_bundle.html(new_row_bundle_price);
			$parent_bundle.html(new_parent_bundle_price);
		});

		// disable line item note if display is unchecked
		$('input[type="checkbox"].display', $form).on('change', function toggleLineItem() {
			var $self = $(this),
			    $note = $self.parents('li.table-row').find('p:nth-child(8) input');

			$note.prop('disabled', !$self.is(':checked'));
		});

		// update balance totals
		$('input[type="checkbox"].include-in-balance-total', $form).on('change', function updateTotals()
		{
			var $self            = $(this),
			    $component_price = $self.parents('.component-price').find('.price'),
			    $balance_totals  = $self.parents('.balance-totals'),
			    $balance_total   = $balance_totals.find('p.balance-total'),
			    $balance         = $balance_totals.find('p.balance'),
			    balance_total    = accounting.unformat($balance_total.html()),
			    component_price  = parseFloat($self.data('price')),
			    posted_payment   = parseFloat($balance_totals.find('p.posted-payment').data('posted-payment'));

			if (!$('input[type="checkbox"].include-in-balance-total:checked').length) {
				Adzuki.StatusMessage('warning', 'You must have at least one vendor included in the balance total.', 'Balance Total');
				$self.prop('checked', true);
				return false;
			}

			if ($self.is(':checked')) {
				$component_price.html(accounting.formatMoney(component_price));
				$balance_total.html(accounting.formatMoney(balance_total + component_price));
				$balance.html(accounting.formatMoney((balance_total + component_price) - posted_payment));
				$('#reservationgenerateinvoice-additional_pages-credit_card_authorization_amount').val(((balance_total + component_price) - posted_payment).toFixed(2));
			}
			else {
				$component_price.html('--');
				$balance_total.html(accounting.formatMoney(balance_total - component_price));
				$balance.html(accounting.formatMoney((balance_total - component_price) - posted_payment));
				$('#reservationgenerateinvoice-additional_pages-credit_card_authorization_amount').val(((balance_total - component_price) - posted_payment).toFixed(2));
			}
		});

		// some items should have the bundle option pre-checked
		// like NCF and stuff, so we do it here in js so it
		// recalculates the bundled amount properly.
		$('input[data-checkme]', $form).prop('checked', true).trigger('change');

		// uncheck insurance quote pricing option if not being included as line item
		$('input[type="checkbox"].include-quote-pricing-line-item', $form).on('change', function toggleInsuranceQuoteInTotal()
		{
			var $self        = $(this),
			    $quote_total = $('input[type="checkbox"].include-quote-pricing-total', $form);

			if ($self.is(':checked')) {
				$quote_total.prop('disabled', false);
			} else {
				$quote_total.prop('disabled', true).prop('checked', false);
			}
		});

		// BUTTANZ!
		$('.btn.submit', $form).on('click', function submitFormAction(e) {
			var $self         = $(this),
			    action        = $self.data('action'),
			    _block_submit = false;

			e.preventDefault();

			// warn when submitting when sending invoice as attachment without a message body
			if (
				action === 'email'
				&& $('#reservationgenerateinvoice-email_options-send_invoice_as_attachment').is(':checked')
				&& !$.trim($('#reservationgenerateinvoice-email_options-message').val())
			) {
				_block_submit = true;
				Adzuki.CustomConfirm({
					body   : 'You chose to send this invoice as an attachment, but you have not entered an email message. Do you wish to send the email without a message?',
					confirm: function submitWithoutMessage() {
						submitForm($self, action);
					}
				});
			}

			if (!_block_submit) {
				submitForm($self, action);
			}
		});

		// cookie-based persistent toggleable sections
		Adzuki.ToggleableSection('[data-toggle="collapse"][data-cookie]');

		// auto-generate a preview so there's not a huge blank space on initial pageload
		$('.btn.btn-primary[data-action="generate-preview"]').click();

		function submitForm($selected_button, action) {
			$('.btn.submit', $form).addClass('disabled');

			$form_action.val(action);
			$form.submit();

			// artificial rate limiting for the download pdf button
			if (action === 'download') {
				$selected_button.removeClass('submit');
				setTimeout(function enableDL() {
					$selected_button.removeClass('disabled').addClass('submit');
				}, 10 * 1000);
			}
		}

		function updateVendorTotal($reservation_vendor) {
			var reservation_vendor_id = $reservation_vendor.data('reservation-vendor-id'),
			    line_item_value       = parseFloat($reservation_vendor.data('price')),
			    $vendor_total         = $('#vendor_total_'+reservation_vendor_id),
			    $component_price      = $vendor_total.find('p.price'),
			    $total_price          = $vendor_total.find('input[type="checkbox"].include-in-balance-total'),
			    total_price           = $total_price.data('price'),
			    $balance_totals  = $vendor_total.parents('.balance-totals'),
			    $balance_total   = $balance_totals.find('p.balance-total'),
			    $balance         = $balance_totals.find('p.balance'),
			    balance_total    = accounting.unformat($balance_total.html()),
			    balance    = accounting.unformat($balance.html());

			// check if included, add to the vendor total
			if ($reservation_vendor.is(':checked')) {
				// included, add to the vendor total
				total_price   += line_item_value;
				balance_total += line_item_value;
				balance       += line_item_value;
			} else {
				// not included, subtract from the vendor total
				total_price   -= line_item_value;
				balance_total -= line_item_value;
				balance       -= line_item_value;
			}

			$total_price.data('price', total_price);
			$component_price.html(accounting.formatMoney(total_price));

			$balance_total.html(accounting.formatMoney(balance_total));
			$balance.html(accounting.formatMoney(balance));
		}
	};

	form.success = function success(data)
	{
		var rand = Math.floor((Math.random() * 10000) + 1),
		    error_message;

		switch (data.status)
		{
			case 'generate-preview':
				$iframe.prop('src', data.data + '?rand=' + rand);
			break;

			case 'print':
				// for fucks sake, IE11...even Edge works correctly (a miracle in it's own right).
				// the other browsers print stuff is in the iframe itself.
				$iframe.on('load', function fuckIE11() {
					if (navigator.userAgent.toLowerCase().indexOf("trident") !== -1) {
						document.getElementById('invoice-preview-iframe').contentWindow.document.execCommand('print', false, null);
					}
				});

				$iframe.prop('src', data.data);
			break;

			case 'download':
				window.location.href = data.data;
			break;

			case 'email_error':
				Adzuki.StatusMessage('warning', data.data, 'Error Sending Email');
			break;

			case 'email_success':
				Adzuki.StatusMessage('success', data.data);
			break;

			case 'text_success':
				Adzuki.StatusMessage('success', data.data);
			break;

			case 'text_error':
				Adzuki.StatusMessage('warning', data.data, 'Error sending text message');
			break;

			case 'validation_error':
				error_message = Adzuki.Form.handleValidationErrors(data.data);
				Adzuki.StatusMessage('error', error_message);
			break;

			default:
				Adzuki.StatusMessage('error', 'Unknown response');
			break;
		}

		$('.btn.submit.disabled').removeClass('disabled');
	};

}(jQuery, window.Adzuki || {}));
